import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {

    private _activeTheme: string = 'theme-light';

    constructor() { }

    switchTheme(theme: string): void {
        document.body.classList.remove(this._activeTheme);
        this._activeTheme = theme;
        document.body.classList.add(this._activeTheme);
    }
}
